<template>
    <dialog-template
        width="400px"
        v-bind="$attrs"
        v-on="$listeners">
        <div class="content">
            <p class="color-333" v-if="content !== ''">{{ content }}</p>
            <slot name="content"/>
        </div>
        <div class="qrcode-wrap">
            <div class="img-wrap">
                <img :src="qrcodeSrc" alt="qrcode">
            </div>
            <p class="color-333">{{ qrcodeDes }}</p>
        </div>
    </dialog-template>
</template>

<script lang='ts'>
import { createComponent } from '@vue/composition-api'

export default createComponent({
    props: {
        content: String,
        qrcodeSrc: String,
        qrcodeDes: String
    }
})
</script>

<style lang="scss" scoped>
.content p {
    line-height: 20px;
}

.qrcode-wrap {
    text-align: center;

    .img-wrap {
        width: 130px;
        height: 130px;
        margin: 20px auto 10px;
        overflow: hidden;

        img {
            width: 100%;
            height: 100%;
            transform: scale(1.2);
        }
    }

    p {
        line-height: 16px;
    }
}
</style>
